import React from 'react'

const Title = () => {
  return (
    <div className='title'>
      <h1>FireGram</h1>
      <h2>Your Pictures</h2>
      <p>Feel free to upload photos by clicing the plus icon!</p>
    </div>
  )
}

export default Title
